module.exports = __webpack_public_path__ + "img/item012.c3a0412c.png";